module.exports = __webpack_public_path__ + "static/media/Warrior Woman.577d3276.jpg";